import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useStyles } from "../../styles/SignDialog";
import Paper from "@mui/material/Paper";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";
import { useCommProvider } from "../../api/CommProvider";
import { useDataProvider } from "../../api/DataProvider";
import { pDataOrigin } from "../../utils/parameters";
import { Tooltip, withStyles } from '@material-ui/core';
import Card from '@mui/material/Card';
import Checkbox from '@mui/material/Checkbox';
import ScoreBarComponent from '../utils/ScoreBarComponent';
import Typography from '@mui/material/Typography';
import Slider, { SliderThumb, SliderValueLabelProps } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { Button, TextField, Divider } from '@mui/material';
import { head } from "lodash";
import { Tabs, Tab } from "@material-ui/core";
import { pRecordsTab, pRecordsVideoTab } from "../../utils/parameters";
import SaveIcon from '@mui/icons-material/Save';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from '@mui/material/Select';
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";


const CustomSlider = styled(Slider)(({ value }) => ({
  //color: '#52af77',
  color: `rgb(${255 - (value*25.5)}, ${(value*25.5)}, 0)`, // Cambia el color de fondo en función del valor
  // color: '#52af77',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: `rgb(${255 - (value*25.5)}, ${(value*25.5)}, 0)`,
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
}));

const DEFAULT_VALIDATION_VALUE = true
const DEFAULT_SCORE_VALUE = 5
const DEFAULT_COMMENT_VALUE = []
const DEFAULT_WARNING_VALUE = ''
const DEFAULT_BLOCKED_VALUE = false
const DEFAULT_EVALUATION_COMMENT_CLASSES = [
  "Signo no reconocido",
  "La configuración no es precisa",
  "Vídeo muy corto",
  "Calidad baja por iluminación inadecuada",
  "Imagen desenfocada",
  "Manos borrosas en movimiento",
  "Encuadre muy cercano",
  "La mano queda fuera del cuadro en parte del signo",
  "Cámara muy baja",
  "Cámara muy alta"
]
const DEFAULT_EVALUATION_DATA = {
    'validation': null,
    'score': null,
    'comment': null,
    'warning': null,
    'blocked': false
}

export function RecordDialog(props) {
  const { openDialog, setOpenDialog, selected_record, selected_video, selected_videoRef, handleRemoveRecord, handleRevertRemoveRecord, updateArr_Records, isEvaluationVisible, isAdmin, type } = props;
  const { t } = useTranslation("global")

  const styles = useStyles();

  const [ tabValue, setTabValue ] = useState(pRecordsTab.resume);
  const [ tabVideo, setTabVideo ] = useState(pRecordsVideoTab.user);

  const [ data_record, set_data_record ] = useState({});
  const [ evaluationData, setEvaluationData ] = useState(DEFAULT_EVALUATION_DATA)
  
  const { updateFeedbackRecord } = useCommProvider();
  const { token_id, currentUser } = useDataProvider();
  const [ isChanged, setIsChanged ] = useState(false)
  const [ selectedDefaultPermission, setSelectedDefaultPermission ] = useState("NONE");

  useEffect(() => {
    function update_selected_record(){

      // console.log("🚀 ~ file: RecordDialog.js:109 ~ RecordDialog ~ evaluationData:", evaluationData)
      // console.log("🚀 ~ file: RecordDialog.js:109 ~ RecordDialog ~ evaluationData   selected_record:", selected_record)

      if (selected_record['feedback_report']!== '-'){
        setEvaluationData(selected_record['feedback_report'])
      }

      // if (isAdmin){
      //   setTabValue(pRecordsTab.evaluation)
      // }

      setSelectedDefaultPermission(selected_record['permission'])

      try{
        set_data_record({
          'id': selected_record['id'] ? selected_record['id'] : selected_record['_id'],
          'origin':  originFormated(selected_record['origin']),
          'lemma':  selected_record['feedback_lemma'],
          'available': (selected_record['available']==true) ? t("sRecorder.record_available"): t("sRecorder.record_pending_delete"),
          'report': (selected_record['report'] == '' ? '' : selected_record['report'][9]),
          'video': selected_video,
          'videoRef': selected_videoRef
        })

      }catch (error){
        console.error(error);
        set_data_record({
          'id': '-',
          'origin': '-',
          'lemma':  '-',
          'available': '-',
          'video': null,
          'videoRef': null
        })
      }
    }
    if (Object.keys(selected_record).length > 0){
      // console.log("🚀 ~ file: RecordDialog.js:135 ~ useEffect ~ selected_record:", selected_record)
      update_selected_record();
    }

    return ()=>{
      setEvaluationData(DEFAULT_EVALUATION_DATA)  //whenever the component removes it will executes
      setTabValue(pRecordsTab.resume)
    }
    
  }, [selected_video]); 
  // }, [selected_record, selected_video]);

  function originFormated(origin) {
    switch (origin) {
      case pDataOrigin.collaboration_LABEL:
        return t("sRecorder.origin_collaboration")
      case pDataOrigin.inference_LABEL:
        return t("sRecorder.origin_inference")
      case pDataOrigin.donate_sign_LABEL:
        return t("sRecorder.origin_donate_sign")
      case pDataOrigin.moveYourSkeleton_LABEL:
        return t("sRecorder.origin_moveYourSkeleton")
      case pDataOrigin.newVariant_LABEL:
        return t("sRecorder.origin_new_variant")
      case pDataOrigin.newSign_LABEL:
        return t("sRecorder.origin_new_sign")
      case pDataOrigin.newDefinition_LABEL:
          return t("sRecorder.origin_new_definition")
      default:
        return t("sRecorder.origin_unkown")
    }
  }

  // useEffect(() => {
  //   console.log('data_record', data_record)
  // },[data_record])

  function onClickCheckbox(clickedElement){
    if (isAdmin){

      let newValue
      if (clickedElement == 'validation') {
        newValue = (evaluationData[clickedElement] != null) ? null : DEFAULT_VALIDATION_VALUE
      }
      if (clickedElement == 'score') {
        newValue = (evaluationData[clickedElement] != null) ? null : DEFAULT_SCORE_VALUE
      }
      if (clickedElement == 'comment') {
        newValue = (evaluationData[clickedElement] != null) ? null : DEFAULT_COMMENT_VALUE
      }

      if (clickedElement == 'warning') {
        newValue = (evaluationData[clickedElement] != null) ? null : DEFAULT_WARNING_VALUE
      }

      if (clickedElement == 'blocked') {
        newValue = (evaluationData[clickedElement] == false) ? true : false
      }
  
      setEvaluationData({
        ...evaluationData,          // Mantén los valores actuales de 'score' y 'comment'
        [clickedElement]: newValue  // Cambia el valor de 'validation' con el nuevo valor
      });
      setIsChanged(true)

    }
    
  }

  const onClickValidationBtn = (validationStatus) => {
    if ( isAdmin ){
      // console.log('onClickValidationBtn: ', validationStatus)
      setEvaluationData({
        ...evaluationData,              // Mantén los valores actuales de 'score' y 'comment'
        'validation': validationStatus  // Cambia el valor de 'validation' con el nuevo valor
      });
      setIsChanged(true)
    }
  };

  const handleSliderChange = (event) => {
    if ( isAdmin ){
      setEvaluationData({
        ...evaluationData,  // Mantén los valores actuales de 'score' y 'comment'
        'score': event.target.value   // Cambia el valor de 'validation' con el nuevo valor
      });
      setIsChanged(true)
    }
  };


  const handleClassesFieldChange = (event) => {
    // console.log("🚀 ~ file: RecordDialog.js:204 ~ handleClassesFieldChange ~ event.target.value:", event.target.value)
    if ( isAdmin ){
      setEvaluationData({
        ...evaluationData,  // Mantén los valores actuales de 'score' y 'comment'
        'comment': event.target.value   // Cambia el valor de 'validation' con el nuevo valor
      });
      setIsChanged(true)
    }
  };

  const handleWarningComment = (event) => {
    // console.log("🚀 ~ file: RecordDialog.js:204 ~ handleClassesFieldChange ~ event.target.value:", event.target.value)
    if ( isAdmin ){
      setEvaluationData({
        ...evaluationData,  // Mantén los valores actuales de 'score' y 'comment'
        'warning': event.target.value   // Cambia el valor de 'validation' con el nuevo valor
      });
      setIsChanged(true)
    }
  };

  async function send_change_to_server(){
    // console.log('data_record: ', data_record)
    // console.log('evaluationData: ', evaluationData)

    const evaluationDataOut = { ...evaluationData };
    if (Array.isArray(evaluationDataOut.comment) && evaluationDataOut.comment.length === 0) {
        evaluationDataOut.comment = null;
    }
    setEvaluationData(evaluationDataOut)
    const response = await updateFeedbackRecord(token_id, currentUser, data_record['id'], evaluationDataOut);

    updateArr_Records()
    setIsChanged(false)
    setOpenDialog(false)
  }


  const handleClickBtnRemove = () => {
    if (data_record['available'] === t("sRecorder.record_available")){
      handleRemoveRecord();
    }else{
      handleRevertRemoveRecord();
    }
    setOpenDialog(false)
  };



  // useEffect(() => {
  //   console.log('evaluationData', evaluationData)
  // },[evaluationData])

  function handleClickClose(){
    setTabValue(pRecordsTab.resume)
    setOpenDialog(false)
  }

  // useEffect(() => {
  //   console.log('isChanged', isChanged)
  // },[isChanged])

  // useEffect(() => {
  //   console.log('recordDialog_task_id', task_id)
  // },[task_id])

  async function handleDefaultPermissionChange(event){
    const permission_update = {'permission' : event.target.value}
    const response = await updateFeedbackRecord(token_id, currentUser, data_record['id'], permission_update);
    setSelectedDefaultPermission(event.target.value)
    updateArr_Records()
  };

  return (
    <Dialog className="sig_SignModal_Dialog" open={openDialog} onClose={handleClickClose} maxWidth="md">
      <DialogTitle className={`sig_RecordDialog_Title_Container ${(data_record['available']=== 'Disponible') ? "sig_RecordDialog_Color_AVAILABLE" : "sig_RecordDialog_Color_DELETED"}`}>
        {/* <div className="sig_RecordDialog_Title">
          {t("sRecorder.record_title")}
        </div> */}
        <div className="sig_RecordDialog_Title" style={{margin:'auto', paddingLeft: '10%'}}>
          {data_record['lemma'] === null || data_record['lemma'] === undefined ? t("sRecorder.record_title") : data_record['lemma'].toUpperCase()}
        </div>
        <div className="sig_RecordDialog_Close_Button">
          <IconButton aria-label="close" onClick={handleClickClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <Tabs
        className="sig_SignModal_Tabs"
        value={tabVideo}
        onChange={(event, newValue) => {
          // console.log('CHANGE TAB: ', newValue)
          setTabVideo(newValue);
        }}
        indicatorColor="primary"
        textColor="primary"
        centered
        >
        
        <Tab className="sig_SignModal_Tab" label= "VÍDEO USUARIO" />
        { selected_videoRef !== undefined && selected_videoRef !== null ? <Tab className="sig_SignModal_Tab" label= "REFERENCIA" /> : <></>}
      </Tabs>

      <DialogContent className="sig_SignModal_DialogContent">

        <ReactPlayer className={styles.signVideo} url={tabVideo === pRecordsVideoTab.user ? selected_video : selected_videoRef } controls={false} playing={true} loop={true} />

        <div style={{overflow: 'auto', width: '100%', height: '100%'}}>

        <Tabs
                    className="sig_SignModal_Tabs"
                    value={tabValue}
                    onChange={(event, newValue) => {
                        // console.log('CHANGE TAB: ', newValue)
                        setTabValue(newValue);
                    }}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                <Tab className="sig_SignModal_Tab" label={t("sRecorder.record_tab_resume").toUpperCase()} />
                {isEvaluationVisible && <Tab className="sig_SignModal_Tab" label={t("sRecorder.record_tab_evaluate").toUpperCase()} />}
        </Tabs>

        {tabValue === pRecordsTab.resume ? (
                  <div className="sig_SignModal_SendFeedbackContainer">
                  <Paper className="sig_SignModal_PaperContent">
                    <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline"> {t("sRecorder.record_field_id")}: </div>
                      <div className="sig_SignModal_PaperBody">{data_record['id']}</div>
                    </div>
                    <div className='sig_SignModal_PaperLine'>
                        <span className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline"> {t("sRecorder.record_field_origen")}: </span>
                        <span className="sig_SignModal_PaperBody">{data_record['origin']}</span>
                    </div>
                    <div className='sig_SignModal_PaperLine'>
                        <span className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline"> {t("sRecorder.record_field_lemmma")}: </span>
                        <span className="sig_SignModal_PaperBody">{data_record['lemma']}</span>
                    </div>
                    <div className='sig_SignModal_PaperLine'>
                        <span className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline"> {t("sRecorder.record_field_state")}: </span>
                        <span className="sig_SignModal_PaperBody">{data_record['available']}</span>
                    </div>
        
                  </Paper>
                </div>
        ): (<></>)}

        {tabValue === pRecordsTab.evaluation ? (
          <>
          <Paper className="sig_Teams_PaperContent">
                <div className='sig_Teams_Info_Root'>
                  <div className='sig_Teams_MainContainer'>

                  {isAdmin ?
                    <IconButton onClick={send_change_to_server} className="sig_Teams_Button_Edit" disabled={!isChanged}>
                      <SaveIcon style={{fontSize: '30px', color: isChanged ? 'red' : '#bdbdbd'}}/>
                    </IconButton>
                  : <></>}

                    <div style={{display: 'flex', width: '100%', margin: 'auto'}}>
                      <Checkbox style={{marginRight: '5px'}} onClick={() => onClickCheckbox('validation')} checked={evaluationData['validation']!= null} />
                      <div> {t("sRecorder.record_field_correct_incorrect")} </div>
                    </div>
                    { evaluationData['validation']!= null ?
                    (
                      <div style={{width: '70%', display: 'flex', border: '1px solid #5ea0d4', borderRadius: '5px' }}>
                        <Button className={`sig_SignDialog_Button`} style={evaluationData['validation'] ? { backgroundColor: 'green', color: 'white' } : { backgroundColor: 'white', color: 'green' }} onClick={() => onClickValidationBtn(true)}>
                          {t("sRecorder.record_success").toUpperCase()}
                        </Button>
                        <Button className={`sig_SignDialog_Button`} style={!evaluationData['validation'] ? { backgroundColor: 'red', color: 'white' } : { backgroundColor: 'white', color: 'red' }} onClick={() => onClickValidationBtn(false)}>
                          {t("sRecorder.record_failure").toUpperCase()}
                        </Button>
                      </div>
                    ): <></> }
                  </div>
                  <Divider style={{backgroundColor: 'white', width:'100%', padding: '5px'}}/>

                  <div className='sig_Teams_MainContainer'>
                    <div style={{display: 'flex', width: '100%', margin: 'auto'}}>
                      <Checkbox style={{marginRight: '5px'}} onClick={() => onClickCheckbox('score')} checked={evaluationData['score']!= null} />
                      <div> {t("sRecorder.record_score")} </div>
                    </div>

                    { evaluationData['score']!= null ?
                    (
                      <>
                        <div style={{display: 'flex', width: '100%', margin: 'auto'}}>
                          <CustomSlider
                            valueLabelDisplay="auto"
                            aria-label="pretto slider"
                            onChange={ handleSliderChange }
                            value={ evaluationData['score'] }
                            min={0}
                            max={10}
                          />
                          <TextField 
                            variant="outlined"
                            // type="number"
                            style={{width: '25%', marginLeft: '10px'}}
                            fullWidth
                            inputProps={{ min: 0, max: 10, step: 1 }}
                            value={ evaluationData['score'] }
                            onChange={ handleSliderChange }
                            InputProps={{
                              style: {
                                padding: '10px',
                                height: '40px'
                              },
                              readOnly: true,
                            }}
                          />
                        </div>
                      </>
                    ): <> <Divider style={{backgroundColor: 'white', width:'100%', padding: '5px'}}/> </> }
                  </div>
                  
                  <div className='sig_Teams_MainContainer'>
                    <div style={{display: 'flex', width: '100%', margin: 'auto'}}>
                      <Checkbox style={{marginRight: '5px'}} onClick={() => onClickCheckbox('comment')} checked={evaluationData['comment']!= null} />
                      <div className="sig_SignModal_PaperTitle">Comentario</div>
                      </div> 
                    </div>
                    { evaluationData['comment']!= null ?
                    (
                      <FormControl>
                        <Select style={{width: '350px', marginTop: '5px'}} multiple value={evaluationData['comment']} onChange={handleClassesFieldChange}>
                          {DEFAULT_EVALUATION_COMMENT_CLASSES.map((item, index) => {
                            return (
                              <MenuItem className="sig_DataSet_MenuListItem" key={item} value={index}>
                                <Checkbox checked={evaluationData['comment'].indexOf(index) > -1} />
                                {item}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    ): <></> }
                </div>
                
          </Paper>
          {(isAdmin || evaluationData['warning']!= null) &&
            <>
            <Paper className="sig_Teams_PaperContent" style={{ backgroundColor: evaluationData['warning'] != null ? '#f68f8f' : '' }} >
              <div className='sig_Teams_Info_Root'>
                <div className='sig_Teams_MainContainer'>
                  <div className='sig_Teams_MainContainer'>
                      <div style={{display: 'flex', width: '100%', margin: 'auto'}}>
                        <Checkbox style={{marginRight: '5px'}} onClick={() => onClickCheckbox('warning')} checked={evaluationData['warning']!= null} />
                        <div className="sig_SignModal_PaperTitle">Reporte error</div>
                      </div> 
                  </div>
                  { evaluationData['warning']!= null ?
                      (
                        <TextField 
                          variant="outlined"
                          fullWidth
                          value={ evaluationData['warning'] }
                          multiline  // Enables multiline input
                          // ref={warningTextRef}
                          onChange={ handleWarningComment }
                        />
                  ): <></> }
                </div>
              </div>
            </Paper>
            <Paper className="sig_Teams_PaperContent" >
              <div className='sig_Teams_Info_Root'>
                <div className='sig_Teams_MainContainer'>
                  <div className='sig_Teams_MainContainer'>
                      <div style={{display: 'flex', width: '100%', margin: 'auto'}}>
                        <Checkbox style={{marginRight: '5px'}} onClick={() => onClickCheckbox('blocked')} checked={evaluationData['blocked']} />
                        <div className="sig_SignModal_PaperTitle"> Bloquear registro </div>
                      </div> 
                  </div>
                </div>
              </div>
            </Paper>
            </>
          }
          </>
              
        ): (<></>)}

        {tabValue === pRecordsTab.resume ? (    
            <>
              {handleRemoveRecord !== undefined ?
                <Tooltip 
                  classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                  placement="top"
                  arrow
                  title={
                    <div className="sig_CustomTooltip_Content">
                      <p>{t("sRecorder.record_note_delete").split('.').map((item, key) => {
                        return <p key={key}>{item.trim()}</p>;
                      })}</p>
                    </div>
                  }>     
                  <Button className={`sig_SignDialog_Button sig_RecordDialog_Button_RecordOptions sig_RecordDialog_Button_RecordOptions_Separator ${(data_record['available']=== 'Disponible') ? "sig_RecordDialog_Color_AVAILABLE" : "sig_RecordDialog_Color_DELETED"}`} onClick={handleClickBtnRemove}>
                    {data_record['available'] === t("sRecorder.record_available") ? t("strButton.btn_remove") : t("strButton.btn_cancel_remove")}
                  </Button>
                </Tooltip>
              :<></>
              }
              
              {type == 'VIDEO' ?
                <div className={`sig_RecordDialog_Button_RecordOptions`}>
                  <div className="sig_SignModal_PaperTitle" style={{color: '#06599B'}}> {t("sRecorder.record_permission_info").toUpperCase()} </div>
                  <div className="sig_Modal_SwitchSelectContainer custom-control custom-switch">
                    <Select
                      className="sig_Teams_Select"
                      id="selectedDefaultPermission"
                      value={selectedDefaultPermission}
                      size="small"
                      onChange={handleDefaultPermissionChange}
                      disabled={isAdmin}
                    >
                      <MenuItem className='sig_ProfileSettings_ListItem' value="VIDEO"> {t("sProfile.permission_video")} </MenuItem>
                      <MenuItem className='sig_ProfileSettings_ListItem' value="KP"> {t("sProfile.permission_kps")} </MenuItem>
                      <MenuItem className='sig_ProfileSettings_ListItem' value="NONE"> {t("sProfile.permission_none")} </MenuItem>
                    </Select>
                  </div>
                </div>
              :<></>
              }
            </>              
          ): (<></>)}
          </div>
      </DialogContent>
    </Dialog>
    
  );
}


